import React from 'react';
import {listExperiments} from '../services/ExperimentService'
import ExperimentRow from "./components/ExperimentRow"
import Pagination from '@mui/material/Pagination';
import { Link } from "react-router-dom";


class Experiments extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            token: props.jwtToken
        };
        this.handlePagination = this.handlePagination.bind(this);
        this.updateData = this.updateData.bind(this);
    }

    updateData(page=0){
        this.setState({data: []});
        listExperiments(this.state.token, page)
            .then(response =>
                {
                    this.setState({data: response});
                }
            );
    }

    handlePagination(event,value){
        this.updateData(value -1)
    }

    componentDidMount() {
        this.updateData();
    }

    render() {
    var renderedRows = [];
    for (var i = 0; i < this.state.data.itemsOnPage; i++) {
        renderedRows.push(<ExperimentRow key={i}
            id={this.state.data.data[i].id}
            name={this.state.data.data[i].name}
            status={this.state.data.data[i].state}
            owned={this.state.data.data[i].owned}
            allowedEdit={this.state.data.data[i].allowedEdit}
            allowedShare={this.state.data.data[i].allowedShare}
            handler={this.updateData}
            jwtToken={this.state.token}
            />
        );
    }

    return (
    <>
        <div className="row" style={{marginLeft: "4%", marginRight: "4%"}}>
            <h1>All experiments
                <Link to="/new">
                    <button style={{float: "right", marginTop:"2px", paddingLeft:"35px", paddingRight:"35px"}}
                    className="btn btn-primary" title="Create new experiment">NEW EXPERIMENT</button>
                </Link>
                <Link to="/shared">
                    <button style={{float: "right", marginTop:"2px", paddingLeft:"35px", paddingRight:"35px",
                        marginRight: "20px"}}
                    className="btn btn-default" title="View shared experiments">VIEW SHARED</button>
                </Link>
            </h1>
            <div style={{ height: 430 }}>
                <table className="table table-hover">
                    <thead>
                        <tr>
                            <th style={{width: "35%"}}>Name</th>
                            <th>State</th>
                            <th>Owned</th>
                            <th>Show</th>
                            <th>Edit</th>
                            <th>Share</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {renderedRows}
                    </tbody>
                </table>
            </div>
            <Pagination sx={{'& .MuiButtonBase-root': {fontSize: "16px"},
            '& .MuiSvgIcon-root': {width: "25px", height: "25px"}
            }} count={this.state.data.totalPages} onChange={this.handlePagination} color="primary"/>
        </div>
    </>
    );
    }
}

export default Experiments;
